module.exports = __webpack_public_path__ + "static/media/Postman.ebb07b43.png";